import type {} from "@lit/react";
import { DetailsSummary as DetailsSummaryElement, } from "@vaadin/details/vaadin-details-summary.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DetailsSummaryElement, };
export type DetailsSummaryEventMap = Readonly<{}>;
const events = {} as DetailsSummaryEventMap;
export type DetailsSummaryProps = WebComponentProps<DetailsSummaryElement, DetailsSummaryEventMap>;
export const DetailsSummary = createComponent({
    elementClass: DetailsSummaryElement, events, react: React, tagName: "vaadin-details-summary"
});
